<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">市场策划</div>
      <div class="t-t2box">
        <div class="t-t2">高效助力品牌精准营销</div>
      </div>
    </div>

    <!-- 第一部分 -->
    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">多渠道打造品牌营销全案</div>
        <br />
        <div class="t2">为您解决品牌传播难题</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao1.png" alt="" />
          </div>
          <div class="text1">新闻营销</div>

          <div class="text2">新闻门户发稿，精选高</div>
          <div class="text3">收录媒体</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao2.png" alt="" />
          </div>
          <div class="text1">媒体邀约</div>

          <div class="text2">纸媒/视媒/网媒记者到场</div>
          <div class="text3">直编发稿权威媒体背书</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao3.png" alt="" />
          </div>
          <div class="text1">微信营销</div>

          <div class="text2">/公众号/朋友圈/社群推广</div>
          <div class="text3">百亿级流量精准曝光</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao4.png" alt="" />
          </div>
          <div class="text1">微博营销</div>

          <div class="text2">话题热搜/微博代运营</div>
          <div class="text3">矩阵传播品牌信息</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao5.png" alt="" />
          </div>
          <div class="text1">品牌维护</div>

          <div class="text2">品牌正面信息铺设</div>
          <div class="text3">专业舆情监测平台</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao6.png" alt="" />
          </div>
          <div class="text1">新媒体种草营销</div>

          <div class="text2">种草、短视频传播</div>
          <div class="text3">KOL为品牌造声浪</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao7.png" alt="" />
          </div>
          <div class="text1">探店营销</div>

          <div class="text2">种草、短视频传播</div>
          <div class="text3">真实体验测文笔记视频 打通线上转线下</div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao7.png" alt="" />
          </div>
          <div class="text1">百科问答</div>

          <div class="text2">种草、短视频传播</div>
          <div class="text3">全网口碑塑造 首选百科问答</div>
        </div>
      </div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <!-- 第二部分 -->
    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">量身定制品牌推广方案</div>
        <br />
        <div class="t2">一站式智能营销</div>
      </div>

      <div class="box2">
        <div class="b1">
          <div class="title">内容策划</div>
          <div class="line"></div>
          <div class="tbox">达人种草传播策略 / 互动营销策划 / 公关 策划 / 公关活动素材创意生产</div>
        </div>

        <div class="b2">
          <div class="title">精准流量</div>
          <div class="line"></div>
          <div class="tbox">全域营销策划 / 全域引流策划 / 私域流量 策划 / 用户沉淀裂变转化率提升</div>
        </div>

        <div class="b3">
          <div class="title">关键触点</div>
          <div class="line"></div>
          <div class="tbox">全链路、跨平台媒体营销策划运营 战略定位 / 核心价值</div>
        </div>

        <div class="b4">
          <div class="title">产品策划</div>
          <div class="line"></div>
          <div class="tbox">产品定位 / 卖点策划 / 定价策略 / 产品 组合 / 包装设计</div>
        </div>

        <div class="b5">推广方案</div>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">我们的优势</div>
        <br />
        <div class="t2">致力于优质的服务完美的解决方案</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao9.png" alt="" />
          </div>
          <div class="textbox">
            <div class="t1">一手价格</div>
            <div class="t2">整合优质资源，首创媒体主与广告 直接对接，省去中间多层环节!</div>
          </div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao10.png" alt="" />
          </div>
          <div class="textbox">
            <div class="t1">功能齐全</div>
            <div class="t2">不停创新，不断开发新功能，保证 发布与售后更方便更快捷！</div>
          </div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao11.png" alt="" />
          </div>
          <div class="textbox">
            <div class="t1">急速发稿</div>
            <div class="t2">不停创新，不断开发新功能，保证 发布与售后更方便更快捷！</div>
          </div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao12.png" alt="" />
          </div>
          <div class="textbox">
            <div class="t1">保证时效</div>
            <div class="t2">发出的媒体，一年之内失效或者被 删可以免费补发</div>
          </div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao13.png" alt="" />
          </div>
          <div class="textbox">
            <div class="t1">合作保障</div>
            <div class="t2">提供正规合同，提供发票，明确双 方职责和义务，合作有保障</div>
          </div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/products/cehua/tubiao14.png" alt="" />
          </div>
          <div class="textbox">
            <div class="t1">专业顾问</div>
            <div class="t2">一对一媒体顾问进行服务，全天24 小时服务，提供方案！</div>
          </div>
        </div>
      </div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <div class="row4">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">我们的资源</div>
        <br />
        <!-- <div class="t2">致力于优质的服务完美的解决方案</div> -->
      </div>

      <!-- 轮播图 -->
      <el-carousel class="swiper" :interval="3000" type="card" height="280px">
        <el-carousel-item class="swi-item" v-for="item in 6" :key="item">
          <img src="@/image/products/cehua/tu1.png" alt="" />

          <div class="img2">
            <div class="title">媒体资源</div>
            <div class="line"></div>
            <div class="tbox">产品定位 / 卖点策划 / 定价策略 / 产品 组合 / 包装设计</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConstProduct',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/cehua/banner.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}
//第一部分
.row1 {
  height: 900px;
  bottom: 20px;

  position: relative;

  .title {
    margin-top: 66px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 55px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 650px;

    margin: 100px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 285px;
      height: 260px;
      // border: 1px solid;
      margin-right: 40px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 90px;
        height: 85px;
        margin: 25px auto 18px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 250px;
        text-align: center;
        margin: 30px auto 16px auto;
        font-size: 18px;
        letter-spacing: 2px;
      }
      .text2 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 2px auto;
        font-size: 15px;
        color: #999999;
      }
      .text3 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 10px auto;
        font-size: 15px;
        color: #999999;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;
      transition-timing-function: linear;
    }
    .item1:hover .text1 {
      color: #4581fb;
    }
  }

  .zixun {
    letter-spacing: 1px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 0px auto;
  }
}

.row2 {
  height: 1060px;
  position: relative;
  overflow: hidden;
  background-color: #313131;
  // 标题
  .title {
    margin-top: 66px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      color: #fff;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 121px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    height: 650px;
    width: 1040px;

    margin: 100px auto;
    position: relative;

    .b1 {
      color: #fff;
      position: absolute;
      width: 400px;
      height: 200px;
      background-color: #3a3a3a;
      top: 0;
      left: 0;

      .title {
        position: absolute;
        font-size: 28px;
        right: 40px;
        top: -20px;
      }
      .line {
        position: absolute;
        top: 100px;
        right: 40px;
        width: 50px;
        height: 4px;
        background-color: #fff;
      }
      .tbox {
        position: absolute;
        color: #eeeeee;
        font-weight: 200;
        width: 65%;
        font-size: 14px;
        text-align: right;
        top: 120px;
        right: 40px;
      }
    }

    .b2 {
      color: #fff;
      position: absolute;
      width: 400px;
      height: 200px;
      background-color: #3a3a3a;
      top: 0;
      right: 0;

      .title {
        position: absolute;
        font-size: 28px;
        left: 40px;
        top: -20px;
      }
      .line {
        position: absolute;
        top: 100px;
        left: 40px;
        width: 50px;
        height: 4px;
        background-color: #fff;
      }
      .tbox {
        position: absolute;
        color: #eeeeee;
        font-weight: 200;
        width: 65%;
        font-size: 14px;
        top: 120px;
        left: 40px;
      }
    }

    .b3 {
      color: #fff;
      position: absolute;
      width: 400px;
      height: 200px;
      background-color: #3a3a3a;
      bottom: 0;
      left: 0;

      .title {
        position: absolute;
        font-size: 28px;
        right: 40px;
        top: -20px;
      }
      .line {
        position: absolute;
        top: 100px;
        right: 40px;
        width: 50px;
        height: 4px;
        background-color: #fff;
      }
      .tbox {
        position: absolute;
        color: #eeeeee;
        font-weight: 200;
        width: 65%;
        font-size: 14px;
        text-align: right;
        top: 120px;
        right: 40px;
      }
    }

    .b4 {
      color: #fff;
      position: absolute;
      width: 400px;
      height: 200px;
      background-color: #3a3a3a;
      bottom: 0;
      right: 0;

      .title {
        position: absolute;
        font-size: 28px;
        left: 40px;
        top: -20px;
      }
      .line {
        position: absolute;
        top: 100px;
        left: 40px;
        width: 50px;
        height: 4px;
        background-color: #fff;
      }
      .tbox {
        position: absolute;
        color: #eeeeee;
        font-weight: 200;
        width: 65%;
        font-size: 14px;
        top: 120px;
        left: 40px;
      }
    }

    .b5 {
      width: 250px;
      height: 250px;
      background: linear-gradient(#9cb9f4, #4581fb);
      position: absolute;
      top: 50%;
      left: 50%;
      color: #fff;
      font-size: 36px;
      line-height: 250px;
      text-align: center;
      border-radius: 50%;
      // transform: translateX(-50%);
      transform: translate(-50%, -50%);
    }

    .b1:hover,
    .b2:hover,
    .b3:hover,
    .b4:hover {
      background-color: #4581fb;
    }
  }
}

.row3 {
  height: 800px;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 60px;
    display: flex;
    color: #000;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 125px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1460px;
    height: 380px;
    padding-left: 60px;
    margin: 130px auto 0 auto;
    box-sizing: border-box;
    // padding-left: 90px;
    padding-top: 15px;

    .item1 {
      width: 395px;
      height: 160px;
      background-color: #f7f8fb;
      // border: 1px solid;
      display: flex;
      // justify-content: center;

      align-items: center;
      margin-right: 60px;
      // margin: 0 60px;
      // box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 64px;
        height: 64px;
        margin-left: 36px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .textbox {
        margin-left: 25px;
        width: 250px;
        color: #000;
        font-size: 18px;
        letter-spacing: 2px;
        .t1 {
          font-size: 20px;
          margin-bottom: 10px;
        }
        .t2 {
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 100px;
    width: 150px;
    left: 50%;
    transform: translateX(-50%);
    height: 50px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
  }
}

.row4 {
  height: 650px;
  background-color: #f7f8fb;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 60px;
    display: flex;
    color: #000;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 125px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // l轮播图
  .swiper {
    margin-top: 70px;
  }
  .swi-item {
    border: 1px solid;
    width: 1040px;
    display: flex;

    img {
      width: 540px;
      height: 280px;
    }

    .img2 {
      position: relative;
      color: #fff;
      width: 540px;
      height: 280px;
      background-color: #81abff;
      .title {
        position: absolute;
        font-size: 28px;
        left: 40px;
        top: 20px;
        color: #fff;
      }
      .line {
        position: absolute;
        top: 133px;
        left: 40px;
        width: 50px;
        height: 4px;
        background-color: #fff;
      }
      .tbox {
        position: absolute;
        color: #eeeeee;
        font-weight: 200;
        width: 65%;
        font-size: 14px;
        top: 160px;
        left: 40px;
      }
    }
  }
}

/deep/ .el-carousel__button {
  margin-top: 75px;
  // 默认按钮的颜色大小等
  width: 40px;
  height: 4px;
  border: none;
  border-radius: 20px;
  background: #bdd3ff;
  opacity: 1;
}

/deep/ .is-active .el-carousel__button {
  // 选中图片的颜色
  background: #4581fb;
  opacity: 1;
}
</style>
